import React from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'

import SearchIndex from '@/pages/ProjectSearch/SearchIndex'

function breadCrumbs() {
  // const location = useLocation()
  // const activePath = location.pathname
  // const [submission] = useGlobalState('submission')
  // will need this ^ when adding show/edit func, see creditscontainer
  const crumbs = [
    { to: '/', name: 'Search Projects' }
  ]
  return crumbs
}

function pageTitle() {
  // const location = useLocation()
  // const activePath = location.pathname
  // const [currentUser] = useGlobalState('currentUser')
  // const { id } = useParams()
  // const [submission] = useGlobalState('submission')
  // will need this ^ when adding show/edit func, see creditscontainer

  const titleInfo = {
    title: 'Search Projects',
    buttons: []
  }

  return titleInfo
}

export default function ProjectSearchContainer(props) {
  const crumbs = breadCrumbs()
  const titleInfo = pageTitle()

  return <>
    <Breadcrumbs>
      { crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100">
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle={titleInfo.title}>
      {titleInfo.buttons}
    </PageTitle>
    <Switch>
      <Route {...props} exact path={['/find_jobs', '/category/:category', '/search', '/']}>
        <SearchIndex />
      </Route>
    </Switch>
  </>
}
